const firebaseConfig = {
    apiKey: "AIzaSyC1IBhXrP7JfS5AsXlwo2ykBPYMhJhUwCw",
    authDomain: "health-care-bff44.firebaseapp.com",
    projectId: "health-care-bff44",
    storageBucket: "health-care-bff44.appspot.com",
    messagingSenderId: "641170138754",
    appId: "1:641170138754:web:a13e6041b954e9979f769b"
  };
  export default firebaseConfig;